import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';

@Component({
  selector: 'app-review-stat-item',
  templateUrl: './review-stat-item.component.html',
  styleUrls: ['./review-stat-item.component.scss'],
})

export class ReviewStatItemComponent implements OnInit {
  @Input() review = undefined;

  constructor(
    private adminSv: AdminServiceService,
    private uiSv: UiService
  ) { }

  ngOnInit() {
  }

  async actionReview(action){
    try{
      await this.uiSv.presentLoader('Cargando...');
      const uri = action ? 'approve' : 'decline';
      await this.adminSv.postReviews(uri, this.review.id);
      await this.uiSv.loading.dismiss();
      await this.uiSv.showToast('Aprobado con éxito');
      this.adminSv.emitApprove.emit();
    }catch(err){
      console.error(err);
      this.uiSv.loading.dismiss();
    }
  }
}
